import { useState } from 'react'
import { TableBlock as TableBlockType } from '../../types/panel'

interface Props { block: TableBlockType }

export default function TableBlock({ block }: Props) {
  const [sortKey, setSortKey] = useState<string | null>(null)
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('asc')

  const handleSort = (key: string) => {
    if (sortKey === key) {
      setSortDir(d => d === 'asc' ? 'desc' : 'asc')
    } else {
      setSortKey(key)
      setSortDir('asc')
    }
  }

  const columns = Array.isArray(block.columns) ? block.columns : []
  const rows = Array.isArray(block.rows) ? block.rows : []

  const sorted = sortKey
    ? [...rows].sort((a, b) => {
        const av = a[sortKey] as string | number, bv = b[sortKey] as string | number
        const cmp = av < bv ? -1 : av > bv ? 1 : 0
        return sortDir === 'asc' ? cmp : -cmp
      })
    : rows

  return (
    <div className="k-block">
      <h4 className="k-block__title">{block.title}</h4>
      <table className="k-table">
        <thead>
          <tr>
            {columns.map(col => (
              <th
                key={col.key}
                className={(col.align === 'right' || col.type === 'num' ? 'is-num ' : '') + 'is-sortable'}
                onClick={() => handleSort(col.key)}
              >
                {col.label}
                {sortKey === col.key && (
                  <span className="k-sort-arrow">{sortDir === 'asc' ? '↑' : '↓'}</span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sorted.map((row, ri) => (
            <tr key={ri}>
              {columns.map((col, ci) => (
                <td
                  key={col.key}
                  className={
                    (col.align === 'right' || col.type === 'num' ? 'is-num ' : '') +
                    (col.type === 'mono' || ci === 0 ? 'mono' : '')
                  }
                >
                  {col.type === 'badge'
                    ? <span className="k-flag" style={{ marginLeft: 0 }}>{String(row[col.key] ?? '')}</span>
                    : String(row[col.key] ?? '')}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
